import React from "react";
import { ArrowUpRight, CheckCircle2 } from "lucide-react";
import { SOURCE_META, THEME_META, formatDate } from "../../lib/catalog";

export default function DossierTable({ articles, opened = [], onOpen }) {
  return (
    <div data-testid="dossier-table" className="border border-[var(--line)] overflow-x-auto">
      <table className="w-full border-collapse min-w-[720px]">
        <thead>
          <tr className="bg-[var(--surface-2)] text-left">
            {["Code", "Title", "Theme", "Source", "Date", ""].map((h) => (
              <th key={h} className="meta-label text-[var(--muted)] text-[0.56rem] px-4 py-3 border-b border-[var(--line)] font-normal">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {articles.map((a, i) => {
            const src = SOURCE_META[a.source];
            const th = THEME_META[a.theme];
            return (
              <tr
                key={a.slug}
                data-testid={`table-row-${a.slug}`}
                onClick={() => { onOpen && onOpen(a.slug); window.open(a.url, "_blank", "noopener,noreferrer"); }}
                className="group cursor-pointer hover:bg-[var(--surface)] transition-colors border-b border-[var(--line)] last:border-0"
              >
                <td className="px-4 py-3.5 meta-label text-[0.56rem] whitespace-nowrap" style={{ color: th.color }}>
                  {th.code}.{String(i + 1).padStart(2, "0")}
                </td>
                <td className="px-4 py-3.5">
                  <span className="font-serif text-[1.05rem] text-[var(--txt)] group-hover:text-[var(--gold-bright)] transition-colors">{a.title}</span>
                  {opened.includes(a.slug) && (
                    <span data-testid={`table-opened-${a.slug}`} className="ml-2 inline-flex items-center gap-1 meta-label text-[0.5rem] text-[var(--muted)] align-middle"><CheckCircle2 size={11} /> Opened</span>
                  )}
                </td>
                <td className="px-4 py-3.5 text-[0.75rem] text-[var(--txt-2)] whitespace-nowrap">{th.short}</td>
                <td className="px-4 py-3.5 whitespace-nowrap">
                  <span className="meta-label text-[0.52rem]" style={{ color: src.text }}>{src.label}</span>
                </td>
                <td className="px-4 py-3.5 meta-label text-[var(--muted)] text-[0.54rem] whitespace-nowrap">
                  {a.is_collection ? "—" : formatDate(a.date)}
                </td>
                <td className="px-4 py-3.5 text-right">
                  <ArrowUpRight size={15} className="inline text-[var(--muted)] group-hover:text-[var(--gold)] transition-colors" />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
